import { NgModule } from '@angular/core';

import { CoachSettingsPageModule } from 'pages/coach-settings/coach-settings.module';
import { CoachClientDetailPageModule } from 'pages/coach-client-detail/coach-client-detail.module';
import { CoachBillingPageModule } from 'pages/coach-billing/coach-billing-page.module';
import { CoachBrandingPageModule } from 'pages/coach-branding/coach-branding.module';
import { CoachCheckoutPageModule } from 'pages/coach-checkout/coach-checkout-page.module';
import { CoachClaimPageModule } from 'pages/coach-claim/coach-claim.module';
import { AwaitingCoachPageModule } from 'pages/awaiting-coach/awaiting-coach.module';
import { SendCoachMessagePageModule } from 'pages/send-coach-message/send-coach-message.module';

const COACH_PAGE_MODULES = [
  CoachSettingsPageModule,
  CoachClientDetailPageModule,
  CoachBillingPageModule,
  CoachBrandingPageModule,
  CoachCheckoutPageModule,
  CoachClaimPageModule,
  AwaitingCoachPageModule,
  SendCoachMessagePageModule,
];

/**
 * The coaching screens — both the coach's own screens and the ones a coached
 * client sees.
 *
 * One of the app's per-area page groups: it only groups page modules together,
 * declaring nothing of its own and adding no providers. Why these files exist and
 * what keeps them honest: `design-docs/angular-components.md`, "Creating New
 * Components", step 4.
 */
@NgModule({
  imports: COACH_PAGE_MODULES,
  exports: COACH_PAGE_MODULES,
})
export class CoachPagesModule { }
